import { render, staticRenderFns } from "./Cancellation.vue?vue&type=template&id=9706d3e2&"
import script from "./Cancellation.vue?vue&type=script&lang=ts&"
export * from "./Cancellation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports